module.exports = __webpack_public_path__ + "img/malbec-rose.968d51ff.jpg";